import { Component, ComponentFactoryResolver, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserWizardComponent } from "../user.wizard";
import { UserFromGroupComponent } from "./user.from.group.component";
import { UserFromGroupWizardService } from "./user.from.group.wizard.service";
import { UserResultsComponent } from "../user-results/user-results.component";
import { ValuesExchangeProvider } from "@nrwl/common-lib";
@Component({
  selector: "user-wizard",
  providers: [UserFromGroupWizardService],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../wizard.user.style.scss","../../../wizard.button.style.scss"]
})
export class UserRemoveWizardComponent extends UserWizardComponent {
  constructor(
    wizardService: UserFromGroupWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider) {
    super(wizardService, changeDetectorRef, activatedRoute, factoryResolver);
  }
  resolveComponentType(pageId: any) {
     if(pageId === "user.from.group.html") {
      this.exchange.notifyListeners('user-profile-role-group-update-done', false);
      return UserFromGroupComponent;
    }
    else if (pageId === "user-results.html") {
      return UserResultsComponent;
    } 
    else {
      console.error("Unrecognized template name:", pageId);
      return null;
    }
  }

  toggleFinish() {
    const result  = this.wizardService.onFinish();
    result.subscribe((outcome) => {
      this.createContentComponent();
      this.exchange.notifyListeners('user-profile-role-group-update-done', true);
    });
  }
}
